@if (!hideHeader) {
  <app-header></app-header>
}
<div class="main-container">
  <h1 class="announcements-title">Announcements</h1>
  <div class="actions-container">
    <span class="subscribe-label" (click)="openSubscribeModal()" (keypress)="handleKeyPress($event)">Subscribe</span>
    @if (this.isPlatform) {
      <button mat-raised-button class="button" (click)="openCreateAnnouncementModal()">New Announcement</button>
    }
  </div>
  <div class="scroll-container right-justify" #scrollContainer (scroll)="onScroll($event)">
    @for (announcement of announcements; track announcement) {
      <div class="announcement-item">
        <div class="announcement-header">
          <div [ngClass]="getAnnouncementClass(announcement.announcementType)">
            <div>[{{announcement.announcementType | uppercase}}] {{announcement.announcementTitle}}</div>
            <div>{{ announcement.announcementDate | date:'MM-dd-yyyy hh:mm a' }}</div>
          </div>
        </div>
        <markdown [data]="announcement.announcementMessage"></markdown>
        @if (this.isPlatform) {
          <div class="announcement-actions">
            <button mat-raised-button class=" button icon-button" (click)="openCreateAnnouncementModal(announcement)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-raised-button class="button icon-button delete-announcement-button" (click)="deleteAnnouncement(announcement)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>
